// tslint:disable:no-reference
/// <reference path="../../../types/svg-image.d.ts" />
import React from "react"

import captureProductImage from "../../resources/images/capture-product.i.svg"
import { LocalizedString, Translator } from "../i18n/Translator"

export interface CaptureProductImageProps {
  /**
   * Alt text for the image.
   */
  altText?: LocalizedString | ""

  /**
   * Translator is used to translate alt text localized string.
   *
   * Injected automatically.
   */
  translator: Translator
}

/**
 * Placeholder illustration prompting the user to capture a product image.
 *
 * This is an internal component inside the Image component
 * injected through props (name="capture-product").
 */
export class CaptureProductImage extends React.PureComponent<CaptureProductImageProps> {
  public render() {
    const { altText, translator } = this.props
    const imageAltText = altText ? translator.lookup(altText) : ""

    return (
      <img
        src={captureProductImage}
        className="capture-product-image"
        alt={imageAltText}
      />
    )
  }
}
